import './App.css';
import React from 'react';
import Navbar from './components/Navbar';
import { BrowserRouter as Router, Routes, Route} from 'react-router-dom'
import Home from './components/pages/Home';
import AboutMe from './components/pages/AboutMe'
import AboutMe2 from './components/pages/AboutMe2';
import { HelmetProvider, Helmet } from 'react-helmet-async';

function App() {
  return (
    <>
    <HelmetProvider>
      <Helmet>
        <title>Kamari Trotz | Portfolio</title>
        <meta name="description" content="Kamari Trotz is a tech professional with experience in cloud computing, software development, and IT automation." />
      </Helmet>
      <Router>
        <Navbar />
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/aboutme' element={<AboutMe/>}/>
            <Route path='/aboutme2' element={<AboutMe2/>}/>

          </Routes>
      </Router>
      </HelmetProvider>
    </>
  );
}

export default App;
